"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AbstractEvent_1 = require("seng-event/lib/AbstractEvent");
var DataEvent = /** @class */ (function (_super) {
    tslib_1.__extends(DataEvent, _super);
    /**
     * Creates a DataEvent object to pass as a parameter to event listeners.
     * @param type The type of event.
     * @param data The data send with the event
     * @param bubbles If true, the event will also go through a bubbling phase. See [[EventDispatcher.dispatchEvent]]
     * for more information on the event phases.
     * @param  (default = false) — Determines whether the Event object participates in the bubbling stage of the event
     * flow. The default value is false.
     * @param cancelable Determines whether the Event object can be canceled. The default values is false.
     */
    function DataEvent(type, data, bubbles, cancelable) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.data = data;
        return _this;
    }
    /**
     * Duplicates an instance of an Event subclass.
     */
    DataEvent.prototype.clone = function () {
        return new DataEvent(this.type, this.data, this.bubbles, this.cancelable);
    };
    return DataEvent;
}(AbstractEvent_1.default));
exports.default = DataEvent;
